module.exports = __webpack_public_path__ + "img/left-page.808045d1.png";